import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import {
  LayoutPlugin,
  BModal,
  BButton,
  NavPlugin,
  BNavbarToggle,
  BCollapse,
  ModalPlugin,
  BFormInput,
  BAlert,
  BFormSelect,
  BFormCheckbox,
  BFormTextarea,
  BDropdown,
  BFormRadio,
  BFormGroup,
  BFormInvalidFeedback,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/font-awesome/scss/font-awesome.scss'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import 'vue-select/dist/vue-select.css'
import './utils/filters/CustomFilters'
import AgentPhoto from './components/shared/AgentPhoto.vue'
import CompanyLogo from './components/shared/CompanyLogo.vue'
import SecondaryCompanyLogo from './components/shared/SecondaryCompanyLogo.vue'
import PoweredBy from './components/shared/PoweredBy.vue'
import Contact from './components/shared/Contact.vue'
import NoDataAvailable from './components/shared/NoDataAvailable.vue'
import preferencesMixin from './utils/mixins/preferencesMixin'
import browser from 'browser-detect'
import ReportHomeSearchPlugin from './plugins/ReportHomeSearch'
import { mapMutations } from 'vuex'
import './misc/resgister-datadog'
import Vue2Filters from 'vue2-filters'
import GoogleMapsPluginV2 from './plugins/GoogleMaps_V2'
import vSelect from 'vue-select'
import clickOutside from './directives/clickOutside'

Vue.use(Loading, {
  canCancel: false,
  color: '#1081a0',
  loader: 'bars',
  backgroundColor: '#000',
  opacity: 0.6,
})
Vue.use(LayoutPlugin)
Vue.component('b-modal', BModal)
Vue.component('b-button', BButton)
Vue.use(NavPlugin)
Vue.component('b-navbar-toggle', BNavbarToggle)
Vue.component('b-collapse', BCollapse)
Vue.use(ModalPlugin)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-alert', BAlert)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-form-checkbox', BFormCheckbox)
Vue.component('b-dropdown', BDropdown)
Vue.component('b-form-radio', BFormRadio)
Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-invalid-feedback', BFormInvalidFeedback)
Vue.component('b-spinner', BSpinner)
Vue.component('b-overlay', BOverlay)
Vue.component('agent-photo', AgentPhoto)
Vue.component('company-logo', CompanyLogo)
Vue.component('secondary-company-logo', SecondaryCompanyLogo)
Vue.component('powered-by', PoweredBy)
Vue.component('contact', Contact)
Vue.component('no-data-available', NoDataAvailable)
Vue.component('v-select', vSelect)
Vue.use(ReportHomeSearchPlugin, { store })
Vue.mixin(preferencesMixin)
Vue.use(Vue2Filters)
Vue.use(GoogleMapsPluginV2)
Vue.directive('click-outside', clickOutside)
Vue.config.productionTip = false

const result = browser()
const body = document.getElementsByTagName('body')[0]
body.classList.add(`${result.name}-print`)

new Vue({
  // @ts-ignore
  router,
  store,
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      loader: [],
    }
  },
  created () {
    this.setBrowserUsed(result)
  },
  methods: {
    ...mapMutations({
      setBrowserUsed: 'report/setBrowserUsed',
    }),
  },
  render: h => h(App),
}).$mount('#app')
